"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyAddProjectV1ProjectsAddPostApplyTextNormalization = void 0;
exports.BodyAddProjectV1ProjectsAddPostApplyTextNormalization = {
    Auto: "auto",
    On: "on",
    Off: "off",
    ApplyEnglish: "apply_english",
};
